export enum EMapItemZIndex {
  INFRASTRUCTURE = 1,
  // к BALLOON_DEFAULT/BALLOON_FAVORITE прибавляется zIndex слота сетки кластера (0..27, см. clusterPins/types).
  // Диапазоны не пересекаются: обычные 5..32 < избранные 50..77 < активный/ховер 100.
  // Избранные всегда выше обычных, активный/ховер — выше всех. Инвариант: FAVORITE + (MAX_COUNT-1) < ACTIVE.
  BALLOON_DEFAULT = 5,
  BALLOON_FAVORITE = 50,
  BALLOON_ACTIVE = 100,
}
